// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let IconV5 = require("../Icon/IconV5.bs.js");
let JsxRuntime = require("react/jsx-runtime");

function TipBox(props) {
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(IconV5.make, {
            icon: "light-bulb",
            size: 28,
            className: "text-white"
          }),
          className: "absolute w-[44px] h-[44px] rounded-full bg-tan-gold-light text-white flex items-center justify-center right-[-11px] top-1/2 -translate-y-1/2 lg:left-0 lg:right-0 lg:top-auto lg:bottom-[-22px] lg:translate-y-0 lg:mx-auto"
        }),
        className: "relative bg-zinc-50 w-[44px] shrink-0 lg:h-[44px] lg:w-auto"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("h3", {
            children: props.title,
            className: "text-2xl leading-[1] mt-0 mb-4 font-light text-zinc-800 md:text-3xl md:mb-6 lg:text-3xl lg:text-center"
          }),
          props.children
        ],
        className: "bg-white pt-5 pr-4 pb-5 pl-8 md:pt-8 md:pr-4 md:pb-8 md:pl-8 lg:p-8 text-zinc-600 text-base leading-[20px]"
      })
    ],
    className: "shadow-sm flex lg:flex-col"
  });
}

let make = TipBox;

exports.make = make;
/* IconV5 Not a pure module */
